<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('tradeIn.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('tradeIn.pageTitle'),
            href: '/admin/trade-in'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info
                  v-model="model"
                  :validate="errors"
                  class="tw-p-3 tw-rounded"
                  ref="info"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList
                  v-model="model"
                  :validate="errors"
                  class="tw-p-3 tw-rounded"
                />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div
                class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
              >
                <ts-button
                  @click.prevent="$router.push({ name: 'trade-in' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  color="primary"
                  :waiting="waiting"
                  @click.prevent="onUpdate"
                  >{{ $t('update') }}</ts-button
                >
              </div>
            </div>
          </form>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import ItemList from './components/item-list.vue'
import Info from './components/info.vue'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'tradeInEdit',
  components: {
    Info,
    ItemList
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      add_new_purchase_type: false,
      waiting_new_purchase_type: false,
      model: {
        trade_in_id: null,
        trade_in_date: moment().format('DD-MM-YYYY'),
        ref_stock_out_id: null,
        reference_no: null,
        customer_id: null,
        currency_id: null,
        input_currency_id: null,
        fx_rate: 1,
        fx_rate_ratio: 1,
        remarks: null,
        invoice_amount: null,
        product_details: []
      }
    }
  },
  computed: {
    ...mapState('stock/tradeIn', ['formViewDatas', 'edit_data'])
  },
  methods: {
    ...mapActions('stock/tradeIn', ['getFormViewModel', 'update', 'find']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .then(async () => {
          await this.find(this.$route.params.id).then(() => {
            this.setEditData()
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.model.trade_in_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'trade-in' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.model.trade_in_id = this.edit_data.trade_in_id
      this.model.trade_in_date = this.edit_data.trade_in_date
      this.model.ref_stock_out_id = this.edit_data.ref_stock_out_id
      this.model.reference_no = this.edit_data.reference_no
      this.model.customer_id = this.edit_data.customer_id
      this.model.currency_id = this.edit_data.currency_id
      this.model.input_currency_id = this.edit_data.input_currency_id
      this.model.fx_rate = this.edit_data.fx_rate
      this.model.fx_rate_ratio = this.edit_data.fx_rate_ratio
      this.model.remarks = this.edit_data.remarks
      this.model.invoice_amount = this.edit_data.invoice_amount

      this.edit_data.trade_in_details.forEach(el => {
        this.model.product_details.push({
          product_id: el.product_id,
          uom_id: el.uom_id,
          quantity: el.quantity,
          cost: el.cost,
          total_amount: el.grand_total,
          currency_id: el.currency_id,
          fx_rate: el.fx_rate,
          fx_rate_ratio: el.fx_rate_ratio,
          serial_list: el.serial_list,
          is_generate_unique_serial: el.product ? el.product.is_generate_unique_serial : false,
          barcode: el.product ? el.product.barcode : null,
          product_name_en: el.product ? el.product.product_name_en : null,
          product_name_kh: el.product ? el.product.product_name_kh : null,
          uom_name_en: el.unit_of_measure
            ? el.unit_of_measure.uom_name_en
            : null,
          uom_name_kh: el.unit_of_measure
            ? el.unit_of_measure.uom_name_kh
            : null,
          input_cost: el.input_cost,
          input_currency_id: el.input_currency_id,
          input_total_amount: el.input_grand_total,
          pro_group_name_en: el.product
            ? el.product.group
              ? el.product.group.pro_group_name_en
              : null
            : null,
          pro_group_name_kh: el.product
            ? el.product.group
              ? el.product.group.pro_group_name_kh
              : null
            : null
        })
      })

      this.getFormViewModel({
        index: 'saleInvoiceDetail',
        params: {
          fnName: 'saleInvoiceDetail',
          stock_out_id: this.edit_data.ref_stock_out_id
        }
      })
        .then(response => {
          this.$refs.info.setData(response.data.saleInvoiceDetail)
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/tradeIn/SET_EDIT_DATA', {})
    next()
  }
}
</script>
